import styled, { css } from 'styled-components';

import { styledReset } from '@pkg/primitives';

import { tokens } from './tokens';
import { LeaderboardDividerVariant as Variant } from './types';

interface StyledDividerProps {
    $variant?: Variant;
}

export const StyledLeaderboard = styled.div`
    ${styledReset.borderBox};
    display: grid;
    gap: ${tokens.leaderboard.gap}px;
`;

export const StyledDivider = styled.hr<StyledDividerProps>`
    ${styledReset.hr};
    --yat_leaderboard-divider-color: rgba(255, 255, 255, 0.2);
    color: var(--yat_leaderboard-divider-color);
    border-style: dashed;
    margin: 5px 0 12px 0;

    ${({ $variant }) => {
        if ($variant === Variant.Positive) {
            return css`
                --yat_leaderboard-divider-color: ${tokens.color.green.asparagus};
            `;
        }

        if ($variant === Variant.Negative) {
            return css`
                --yat_leaderboard-divider-color: ${tokens.color.red.china};
            `;
        }
    }};

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        margin: ${tokens.leaderboard.gap * 0.5}px 0;
    }
`;

// export const StyledList = styled.ol`
export const StyledList = styled.div`
    ${styledReset.list};
    display: grid;
    gap: ${tokens.list.gap}px;
`;

export const SkeletonList = styled(StyledList)`
    gap: 10px;
    display: flex;
    flex-direction: column;
`;
